import { useEffect, useState } from 'react';
import type { SessionProfile } from '@growth-rings/fmos-schema';
import { supabase } from '../lib/supabase';

export function ReferralProgramView({ profile }: { profile: SessionProfile }) {
  const [guildId,setGuildId]=useState('');
  const [count,setCount]=useState<number|null>(null);
  const [message,setMessage]=useState('');
  useEffect(()=>{
    if(!supabase)return;
    void supabase.from('profiles').select('guild_id').eq('id',profile.id).single().then(({data,error})=>{
      if(error){setMessage('Your Guild referral identity could not be loaded.');return}
      setGuildId(data?.guild_id||'');
    });
    void supabase.from('referral_attributions').select('id',{count:'exact',head:true}).eq('inviter_profile_id',profile.id).then(({count,error})=>{
      if(!error)setCount(count??0);
    });
  },[profile.id]);
  const referralUrl=guildId?`${window.location.origin}/?auth=register&guild=${encodeURIComponent(guildId)}`:'';
  async function copyLink(){
    if(!referralUrl)return;
    try{await navigator.clipboard.writeText(referralUrl);setMessage('Referral signup link copied.')}
    catch{setMessage('Copy the link shown below.')}
  }
  return <section className="panel referral-program">
    <div className="panel-heading"><div><span className="pill blue">Referral connections</span><h2>Invite people through your Guild identity.</h2><p>A new member who registers with this link is attributed to you at the standard 5% membership-revenue share. Growth Rings may assign a higher documented program rate to eligible Professional Studio partners; the rate is captured with the referral record and is not editable by either party.</p></div>{count!==null&&<span className="pill">{count} referred</span>}</div>
    <div className="referral-link-row"><div><span className="fine">Your Guild ID</span><strong>{guildId||'Preparing…'}</strong>{referralUrl&&<code>{referralUrl}</code>}</div><button type="button" className="button primary" disabled={!referralUrl} onClick={()=>void copyLink()}>Copy signup link</button></div>
    <p className="fine">Attribution records a relationship; it does not itself move money. Earnings and payout eligibility remain visible records until the payout workflow is activated and the recipient completes Stripe verification.</p>
    {message&&<p className="form-status" role="status">{message}</p>}
  </section>;
}
